// components/BooleanField.js
export default function BooleanField({ value, onChange, mode, config, ...props }) {
    console.log('BooleanField render:', { value, mode, config });
    
    if (mode === "view") return <span>{value ? "Yes" : "No"}</span>;
    
    const handleChange = (e) => {
        console.log('BooleanField onChange triggered:', e.target.checked);
        console.log('Event object:', e);
        onChange(e.target.checked);
    };
    
    const handleClick = (e) => {
        console.log('BooleanField onClick triggered:', e);
    };
    
    // Force boolean value
    const checkedValue = Boolean(value);
    console.log('BooleanField checkedValue:', checkedValue);
    
    return (
        <div style={{ position: 'relative', zIndex: 1000 }}>
            <input 
                type="checkbox" 
                checked={checkedValue} 
                onChange={handleChange}
                onClick={handleClick}
                className="form-check-input"
                style={{ 
                    cursor: 'pointer',
                    position: 'relative',
                    zIndex: 1001,
                    pointerEvents: 'auto'
                }}
                {...props}
            />
        </div>
    );
}